module.exports = __webpack_public_path__ + "media/images/ui__infoBox--dark-ea1562b847c34d6baca01cc91bf6028e.png";